module.exports = __webpack_public_path__ + "static/media/poweredByRelishNDnBV2.db7b71f0.png";